import { render, staticRenderFns } from "./indexPerson.vue?vue&type=template&id=14c30d64&"
import script from "./indexPerson.vue?vue&type=script&lang=ts&"
export * from "./indexPerson.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports